import React, {Component} from 'react';
import Paper from 'material-ui/Paper';
import List, {ListItem} from 'material-ui/List';
import Credit from 'material-ui/svg-icons/action/credit-card';
import Time from 'material-ui/svg-icons/av/av-timer';
import Clip from 'material-ui/svg-icons/action/assignment';

import Pago from '../../Models/Pago';

import Solicitar from '../../components/Suscripcion/Solicitar.jsx';
import Pedido from '../../components/Suscripcion/Pedido.jsx';
import NewPago from '../../components/Suscripcion/NewPago.jsx';
import Pagos from '../../components/Suscripcion/Pagos.jsx';

import AuthStore from '../../reflux/stores/AuthStore';
import AuthActions from '../../reflux/AuthActions';
import AlertActions from '../../reflux/AlertActions';



class Suscripcion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            pago: new Pago({}),
            servicios: [],
            tipospago: [],
            servicio: '3',
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.changeServicio = this.changeServicio.bind(this);
        this.onSolicitar = this.onSolicitar.bind(this);
    }

    componentWillMount() {
        AlertActions.configureAppBar('Suscripción', null);
        AuthActions.getUser();
        this.unsubscribe = AuthStore.listen(this.handleAuth);
    }
    
    componentWillUnmount() {
        this.unsubscribe();
    }
    
    handleAuth(e, user, extras) {

        if (e === 'getUser')
            this.setState({user: user, servicios: extras.servicios, tipospago: extras.tipospago});

        if (e === 'putUser')
            AlertActions.alert('open', 'Perfil editado', 'Ha editado su perfil satisfactoriamente');

        if (e === 'createdPago') {
            AlertActions.alert('open', 'Pago cargado', 'Usted ha cargado un pago correctamente, por favor aguarde a su verificación');
            this.setState({pago: new Pago({})});
        }

    }

    onInputChange(e, value, otro) {
        
        let pago = this.state.pago;

        if (e.target.name === 'soporte')
            pago[e.target.name] = e.target.files[0];
        else if (e.target.name === undefined)
            pago['tipo_pago_id'] = otro;
        else
            pago[e.target.name] = value;

        this.setState({pago: pago});
    }

    changeServicio(e, value) {
        this.setState({servicio: value});
    }

    onSolicitar(e, val) {
        AlertActions.startLoading();
        AuthActions.solicitar(this.state.servicio);
    }

    onSubmit(e) {
        e.preventDefault();
        let pago = this.state.pago;
        pago.pedido_id = this.state.user.cliente.pedido[0].id;

        console.log(pago);

        AuthActions.newPago(pago);
    }
    render() {
        if (this.state.user === null) return null;
            
        const cliente = this.state.user.cliente;
        const suscripcion = cliente.suscripcion;
        const servicio = suscripcion.servicio;
        const pedido = cliente.pedido[0];

        const paperStyle = {
            padding: '5px 20px 20px 20px',
            marginTop:35
        };
        const titleS = {
            marginTop:0, 
            marginBottom:10
        };

        const titleSyl = {
            marginTop:15, 
            marginBottom:10
        };

        const LiStyle = {
            padding: 10,
        };

        const suscripcionStyle = cliente.pedido.length < 1 
        ?   {
                flexBasis: '100%',
                maxWidth: '100%',
                margin:'auto'
            } 
        : null;

        return (
            <div className="row">
                <div className="col-xs-12 col-sm-6" style={suscripcionStyle} >
                    <Paper style={paperStyle}>
                        <h2 className="center" style={titleSyl}>Suscripción</h2>
                        <List>
                            <ListItem 
                                innerDivStyle={LiStyle} 
                                disableTouchRipple={true}
                                rightIcon={<Credit />}>
                                <h4 style={titleS}>Plan Actual</h4>
                                {servicio.descripcion}
                            </ListItem>

                            <ListItem 
                                innerDivStyle={LiStyle} 
                                disableTouchRipple={true}
                                rightIcon={<Time />}>
                                <h4 style={titleS}>Tiempo Restante</h4>
                                {suscripcion.days_left+' días'}
                            </ListItem>

                            <Solicitar
                                innerDivStyle={LiStyle}
                                show={(suscripcion.days_left < 30 && cliente.pedido.length < 1)}
                                titleStyle={titleS}
                                changeServicio={this.changeServicio}
                                selected={this.state.servicio}
                                servicios={this.state.servicios}
                                onSolicitar={this.onSolicitar} />

                            <Pedido
                                innerDivStyle={LiStyle} 
                                show={cliente.pedido.length > 0}
                                titleStyle={titleS} 
                                pedido={pedido}
                                rightIcon={<Clip />}
                                />

                            <Pagos
                                innerDivStyle={LiStyle}
                                show={suscripcion.days_left < 31 && cliente.pedido.length > 0} 
                                pedido={pedido}
                                paperStyle={paperStyle}
                                />
                        </List>
                    </Paper>
                </div>

                <div className="col-sm-6 col-xs-12">
                    <NewPago
                        tipos={this.state.tipospago}
                        show={suscripcion.days_left < 31 && cliente.pedido.length > 0}
                        paperStyle={paperStyle}
                        onSubmit={this.onSubmit}
                        onInputChange={this.onInputChange}
                        pago={this.state.pago} />
                </div>
            </div>
        );
        

    }
}

export default Suscripcion;


/** WEBPACK FOOTER **
 ** ./app-react/pages/User/Suscripcion.jsx
 **/